import { render } from "./GroupBuyNav.vue?vue&type=template&id=33de48ea&scoped=true"
import script from "./GroupBuyNav.vue?vue&type=script&lang=js"
export * from "./GroupBuyNav.vue?vue&type=script&lang=js"

import "./GroupBuyNav.vue?vue&type=style&index=0&id=33de48ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33de48ea"]])

export default __exports__